import { render, staticRenderFns } from "./genPrvkey.vue?vue&type=template&id=4c8c307c&scoped=true&"
import script from "./genPrvkey.vue?vue&type=script&lang=js&"
export * from "./genPrvkey.vue?vue&type=script&lang=js&"
import style0 from "./genPrvkey.vue?vue&type=style&index=0&id=4c8c307c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8c307c",
  null
  
)

export default component.exports